import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import { Formik, Form, Field } from "formik";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import swal from "sweetalert";
import { utils } from "../../../utils";

class CreateNonSODEModal extends Component {
    constructor(props) {
        super(props);
        this.data = null;
        this.state = {
            modal: false,
            category: null,
            sub_category: null,
            categories: [],
            sub_categories: [],
            service_units: [],
            req_categories: false,
            req_sub_categories: false,
            req_service_units: false,
            budget_approval: true,
        };
    }

    componentWillMount() {
        // this.filter_category();
        // this.filter_sub_category();
        // this.filter_service_unit();
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal,
            category: null,
            sub_category: null
        });
    };

    onSubmit = (values, formik) => {
        this.setState({ fail: true });
        // const data = {
        //     circle: values.circle,
        //     requested_quantity: values.requested_quantity,
        //     description: values.description,
        //     customer_team: values.customer_team,
        //     category: values.category,
        //     sub_category: values.sub_category,
        //     service_unit: values.service_unit,
        //     project_name: values.project_name,
        // }

        this.props
            .onSubmit(values)
            .then(() => {
                formik.setSubmitting(false);
                this.toggle();
            })
            .catch(error => {
                swal({
                    title: "Error!",
                    text: utils.computeError(error),
                    icon: "error",
                    button: true
                });
            });
    };

    budgetApprovalHandler = (val, setFieldValue) => {
        const category = this.state.categories.find(el => el.value === val);
        this.setState({budget_approval: !category.budget_approval });
        setFieldValue("requested_quantity", 0, false);
        setFieldValue("description", "", false);
    }

    renderOps = ops => {
        if (ops) {
            return ops.map(op => ({
                label: op.display,
                value: op.value
            }));
        }
        return [];
    };

    filterVal = val => {
        return this.props.listCircles(val);
    };

    filter_category = (customer_team = null) => {
        const filters = { field: "category", customer_team };
        this.setState({  categories: [], req_categories: true });
        return this.props.getChoices(filters).then(data => {
            this.setState({ categories: data, req_categories: false });
        });
    };

    filter_sub_category = (customer_team = null, category = null) => {
        const filters = { field: "sub_category", customer_team, category };
        this.setState({ sub_categories: [], req_sub_categories: true });
        return this.props.getChoices(filters).then(data => {
            this.setState({ sub_categories: data, req_sub_categories: false });
        });
    };

    filter_service_unit = (customer_team = null, category = null, sub_category = null) => {
        const filters = {
            field: "service_unit",
            customer_team,
            category,
            sub_category
        };
        this.setState({ service_units: [], req_service_units: true });
        return this.props.getChoices(filters).then(data => {
            this.setState({ service_units: data, req_service_units: false});
        });
    };

    validateGeneral = value => {
        let error;
        if (!value) {
            error = "This field is required";
        }
        return error;
    };

    renderError = (formik, type) => {
        if (formik.errors.hasOwnProperty(type) && formik.errors[type]) {
            return <small className="text-danger form-text">{formik.errors[type]}</small>;
        }
        return null;
    };

    filterOps = (ops, value) => {
        return ops ? ops.find(c => c.value === value) || "" : "";
    };

    render() {
        const { modal } = this.state;
        const { customerTeams } = this.props;
        const initialValues = {
            sub_category: "",
            customer_team: "",
            circle: "",
            category: "",
            service_unit: "",
            requested_quantity: "",
            description: "",
        };
        return (
            <div>
                <Modal isOpen={modal} toggle={this.toggle} size="xl" centered style={{ width: "770px" }}>
                    <ModalHeader>Create non SODE</ModalHeader>
                    <ModalBody>
                        <Formik onSubmit={this.onSubmit} initialValues={initialValues}>
                            {({ values: v, ...formik }) => {
                                return (
                                    <Form className="form">
                                        <div className="fields">
                                            <Row>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Customer Team</label>
                                                        <Field
                                                            component={Select}
                                                            name="customer_team"
                                                            validate={this.validateGeneral}
                                                            isClearable
                                                            options={this.renderOps(customerTeams)}
                                                            onChange={val => {
                                                                val = val ? val.value : "";
                                                                formik.setFieldValue("customer_team", val, false);
                                                                formik.setFieldValue("category", "", false);
                                                                formik.setFieldValue("sub_category", "", false);
                                                                formik.setFieldValue("service_unit", "", false);
                                                                if (val !== "") {
                                                                    this.filter_category(val);
                                                                }
                                                            }}
                                                        />
                                                        {this.renderError(formik, "customer_team")}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Circle</label>
                                                        <Field
                                                            name="circle"
                                                            component={AsyncSelect}
                                                            validate={this.validateGeneral}
                                                            isClearable
                                                            cacheOptions
                                                            defaultOptions
                                                            loadOptions={val => this.filterVal(val)}
                                                            onChange={val => {
                                                                val = val ? val.value : "";
                                                                formik.setFieldValue("circle", val, false);
                                                            }}
                                                        />
                                                        {this.renderError(formik, "circle")}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Budget</label>
                                                        <Field
                                                            name="requested_quantity"
                                                            validate={!this.state.budget_approval ? this.validateGeneral : null}
                                                            type="number"
                                                            className="form-control"
                                                            disabled={this.state.budget_approval}
                                                        />
                                                        {!this.state.budget_approval ? this.renderError(formik, "requested_quantity"): null}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Category</label>
                                                        <Field
                                                            name="category"
                                                            component={Select}
                                                            validate={this.validateGeneral}
                                                            value={this.filterOps(this.state.categories, v.category)}
                                                            isClearable
                                                            defaultOptions
                                                            options={this.state.categories}
                                                            isDisabled={v.customer_team === "" && !this.state.req_categories}
                                                            onChange={val => {
                                                                val = val ? val.value : "";
                                                                formik.setFieldValue("category", val, false);
                                                                formik.setFieldValue("sub_category", "", false);
                                                                formik.setFieldValue("service_unit", "", false);
                                                                if (val !== "") {
                                                                    this.filter_sub_category(v.customer_team, val);
                                                                    this.budgetApprovalHandler(val, formik.setFieldValue)
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Sub category</label>
                                                        <Field
                                                            name="sub_category"
                                                            component={Select}
                                                            validate={this.validateGeneral}
                                                            isDisabled={v.category === "" && !this.state.req_sub_categories}
                                                            value={this.filterOps(
                                                                this.state.sub_categories,
                                                                v.sub_category
                                                            )}
                                                            isClearable
                                                            defaultOptions
                                                            options={this.state.sub_categories}
                                                            onChange={val => {
                                                                val = val ? val.value : "";
                                                                formik.setFieldValue("sub_category", val, false);
                                                                formik.setFieldValue("service_unit", "", false);
                                                                if (val !== "") {
                                                                    this.filter_service_unit(
                                                                        v.customer_team,
                                                                        v.category,
                                                                        val
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Service unit</label>
                                                        <Field
                                                            name="service_unit"
                                                            component={Select}
                                                            validate={this.validateGeneral}
                                                            value={this.filterOps(
                                                                this.state.service_units,
                                                                v.service_unit
                                                            )}
                                                            isDisabled={v.sub_category === "" && !this.state.req_service_units}
                                                            isClearable
                                                            options={this.state.service_units}
                                                            onChange={val => {
                                                                val = val ? val.value : "";
                                                                formik.setFieldValue("service_unit", val, false);
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="form-group">
                                                        <label>Project name</label>
                                                        <Field
                                                            name="project_name"
                                                            type="text"
                                                            validate={this.validateGeneral}
                                                            className="form-control"
                                                        />
                                                        {this.renderError(formik, "project_name")}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="form-group">
                                                        <label>Remarks</label>
                                                        <Field
                                                            name="description"
                                                            type="text"
                                                            className="form-control"
                                                            disabled={this.state.budget_approval}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="row controls">
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    style={{ width: "175px" }}
                                                    className="mr-1"
                                                >
                                                    {!this.state.budget_approval ?  "Send to approval" : "Create"}
                                                    
                                                </Button>
                                                <Button
                                                    className="btn-danger mr-1"
                                                    onClick={this.toggle}
                                                    type="button"
                                                    name="Close"
                                                    style={{ width: "175px" }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default CreateNonSODEModal;
